import React from 'react';
import { fileIcons } from '../../providers/file-extension-icons';
import { Container, CardBox, CardFileTypeImage, Checkbox } from './styles';

const CardFile = ({ doc, selectable = false, selected = false, onToggleSelect }) => {
  const { url, name } = doc;
  const extension = name.split('.').pop().toLowerCase() || 'file';
  const iconSrc = fileIcons[extension]
    ? fileIcons[extension].icon
    : fileIcons.file.icon;

  function toTitleCase(str) {
    return str
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  return (
    <Container id='card-file-container'>
      {selectable && (
        <Checkbox
          id={`select-${name}`}
          type='checkbox'
          checked={selected}
          onChange={() => onToggleSelect && onToggleSelect(name)}
          onClick={(e) => e.stopPropagation()}
        />
      )}
      <a
        id='card-file-link'
        href={url}
        target='_blank'
        rel='noopener noreferrer'
        style={{
          textDecoration: 'none',
          color: 'inherit',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CardBox id='card-box' key={url}>
          <CardFileTypeImage src={iconSrc} alt={`${extension} file icon`} />
        </CardBox>
        <span
          style={{
            display: 'block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            width: '95%',
            textAlign: 'center',
          }}
          title={toTitleCase(name)}
        >
          {toTitleCase(name)}
        </span>
      </a>
    </Container>
  );
};

export default CardFile;
